module.exports = __webpack_public_path__ + "img/info6_.5ff2841a.png";